import React, { useEffect, useState } from "react";
import { Layout, Typography, Avatar, Spin, Table, message } from "antd";
import { UserOutlined } from "@ant-design/icons";
import Sidebar from "./Sidebar";
import { BASE_URL } from "./config";
import HeaderBar from "./HeaderBar";
import Footer from "./Footer";

const { Header, Content, Sider } = Layout;
const { Title } = Typography;

const Accounts = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [user, setUser] = useState(null);
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log("🔹 Accounts component mounted");

    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUser(parsedUser);
      console.log("👤 Logged in user from localStorage:", parsedUser);

      const companyId = parsedUser.company_id;
      console.log(`🏢 Fetching account transactions for Company ID: ${companyId}`);

      // Fetch account transactions for this company
      fetch(`${BASE_URL}/get_accounts.php?company_id=${companyId}`)
        .then((res) => {
          console.log("📡 Raw API response object:", res);
          return res.json();
        })
        .then((res) => {
          console.log("📦 Parsed API response JSON:", res);

          if (res.status === "success") {
            console.log(`✅ Transactions fetched successfully (${res.data.length} records)`);
            setAccounts(res.data);
          } else {
            console.warn("⚠️ No transaction records found or API returned error:", res.message);
            message.warning("No transaction records found.");
          }
          setLoading(false);
        })
        .catch((err) => {
          console.error("❌ Error fetching accounts data:", err);
          message.error("Failed to load account transactions.");
          setLoading(false);
        });
    } else {
      console.warn("⚠️ No user found in localStorage. Redirect or login check needed.");
      setLoading(false);
    }

    // Cleanup log
    return () => {
      console.log("🧹 Accounts component unmounted");
    };
  }, []);

  // Define table columns
  const columns = [
    {
      title: "Sr No",
      dataIndex: "srno",
      key: "srno",
      render: (_, __, index) => index + 1,
    },
      {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Transaction ID",
      dataIndex: "transaction_id",
      key: "transaction_id",
    },
    {
      title: "Company ID",
      dataIndex: "company_id",
      key: "company_id",
    },
    {
      title: "Credit (₹)",
      dataIndex: "credit",
      key: "credit",
      render: (text) => <span style={{ color: "green" }}>{text || "-"}</span>,
    },
    {
      title: "Debit (₹)",
      dataIndex: "debit",
      key: "debit",
      render: (text) => <span style={{ color: "red" }}>{text || "-"}</span>,
    },
    {
      title: "Balance (₹)",
      dataIndex: "balance",
      key: "balance",
      render: (text) => <b>{text}</b>,
    },
    {
      title: "Type (CR/DB)",
      dataIndex: "type",
      key: "type",
    },
    
    {
      title: "User From",
      dataIndex: "user_from",
      key: "user_from",
    },
    {
      title: "Invoice No",
      dataIndex: "invoice_no",
      key: "invoice_no",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "remarks",
    },
  ];

  // Log whenever data updates
  useEffect(() => {
    if (accounts.length > 0) {
      console.log("🧾 Accounts data updated:", accounts);
    }
  }, [accounts]);

  return (
    <Layout style={{ minHeight: "100vh", fontFamily: "Poppins, sans-serif" }}>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={(value) => {
          console.log("📘 Sidebar collapsed state changed:", value);
          setCollapsed(value);
        }}
        breakpoint="lg"
        collapsedWidth="80"
      >
        <Sidebar collapsed={collapsed} user={user} />
      </Sider>

      <Layout>
        <HeaderBar title="Accounts" />

        <Content style={{ margin: 24 }}>
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "70vh",
              }}
            >
              <Spin size="large" tip="Loading transactions..." />
            </div>
          ) : (
            <Table
              dataSource={accounts}
              columns={columns}
              rowKey="transaction_id"
              bordered
              pagination={{ pageSize: 10 }}
              style={{
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              }}
              onChange={(pagination, filters, sorter) => {
                console.log("📊 Table change:", { pagination, filters, sorter });
              }}
            />
          )}
        </Content>
        <Footer user={user}/>
      </Layout>
    </Layout>
  );
};

export default Accounts;
